import { type PropsWithChildren } from 'react';
import { Modal } from './joy/Modal';
import { ModalDialog } from './joy/ModalDialog';
import { Button } from './joy/Button';
import { Typography } from './joy/Typography';
import { ModalClose } from './joy/ModalClose';
import { Stack } from './joy/Stack';
import { Trans } from '@lingui/react';

interface Props {
  open?: boolean;
  header: React.ReactNode;
  cancelLabel?: React.ReactNode;
  onCancel: () => void;
  onConfirm: () => void;
  maxWidth?: React.ComponentProps<typeof ModalDialog>['maxWidth'];
  confirmProps?: React.ComponentProps<typeof Button>;
}

export const ConfirmDialog = ({
  open = true,
  header,
  cancelLabel = <Trans id="Cancel" />,
  onCancel,
  onConfirm,
  children,
  maxWidth,
  confirmProps,
}: PropsWithChildren<Props>) => {
  return (
    <Modal open={open} onClose={onCancel}>
      <ModalDialog maxWidth={maxWidth}>
        <ModalClose />
        <Stack margin={3} gap={3}>
          <Typography level="h4">{header}</Typography>
          {children}
          <Stack direction="row" gap={1} justifyItems="end" alignSelf="end">
            <Button onClick={onCancel} color="neutral">
              {cancelLabel}
            </Button>
            <Button onClick={onConfirm} color={'primary'} {...confirmProps}>
              {confirmProps?.children ?? <Trans id="Ok" />}
            </Button>
          </Stack>
        </Stack>
      </ModalDialog>
    </Modal>
  );
};
